<template>
  <offer-applied-message
    source="menu-page"
    :removePaddingExtra="showSearchModal"
    v-if="!loyaltyCard"
  ></offer-applied-message>
  <div
    class="botm-bar-wrap"
    v-if="cartQuantity > 0"
    :class="{ 'menu-loyalty-footer-cart': loyaltyCard }"
  >
    <div
      class="bottom-nav active"
      :class="{ 'with-checkout hauto': cartQuantity > 0 }"
    >
      <span
        class="nav-item cart-nav"
        :class="[!loyaltyCard ? 'm10 w100 mw100' : 'mt0 mr0']"
        @click="handleCartClick($event)"
      >
        <div
          v-if="cartQuantity >= 0"
          class="pt9 btn btn-checkout disp-col-inline"
          :class="[!loyaltyCard ? 'w100 mw100' : '']"
        >
          <span v-if="!loyaltyCard">
            <span class="fs-14" v-if="!hideCartTotal"
              ><span class="bolder">{{ currencySymbol }}</span>
              <span class="bold"> {{ cartTotal }} + taxes </span>
            </span>
            <span
              class="block tl"
              :class="[!hideCartTotal ? 'fs-11' : 'fs-13']"
            >
              {{ cartQuantity }} {{ cartQuantity > 1 ? "items" : "item" }}</span
            >
          </span>
          <span :class="[loyaltyCard ? 'd-flex' : 'ml10 tl d-flex']">
            <span class="cart-total mr3" :class="[hideCartTotal ? 'mt3' : '']">
              <transition name="slide-fade" mode="out-in">
                <span class="count-holder" :key="cartQuantity">{{
                  cartQuantity
                }}</span>
              </transition>
              <i aria-hidden="true" class="jfi-cart fs-18"></i>
            </span>
            <span
              class="fs-14 bold ml12 mr15"
              :class="[hideCartTotal ? 'mt6 mb6' : '']"
              v-html="checkoutTitle"
            ></span>
            <i aria-hidden="true" class="jfi-arrow-line fs-14"></i>
          </span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import { keyMapsGetter, keyMapsMutation } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import { v2PwaBasePath } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import userActivityTracking from "../helpers/UserActivityTracking";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";
import OfferAppliedMessage from "./OfferAppliedMessage.vue";
import { CURRENCY_SYMBOL } from "../helpers/paymentConstants";

export default {
  name: "SearchBottomBar",
  props: ["showSearchModal", "loyaltyCard"],
  components: {
    OfferAppliedMessage,
  },
  data() {
    return {
      platform: "",
      currencySymbol: CURRENCY_SYMBOL
    };
  },
  mounted() {
    const queryObj = Utility.getQueryFromUrlWithSpace(window.location.href);
    this.platform = queryObj["platform"] || false;
  },
  methods: {
    eventFunction(isClicked = false, eObj = {}, eventName = "") {
      let eventType = isClicked ? "Click" : "Impression";
      if (eventName) {
        eventType = eventName;
      }
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = { ...eObj };
      let sectionPosition = preEventObj["sectionPosition"];
      delete preEventObj["sectionPosition"];
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        preEventObj["sectionName"] ? preEventObj["sectionName"] : "search",
        sectionPosition,
        preEventObj,
      );

      if (this.platform) {
        Utility.sendEventToApp(eventType, eventObj);
      } else {
        setEvents("amplitude", eventType, eventObj);
      }
    },

    handleCartClick(event, item) {
      //Amplitude click event load
      LocalStorageFunc.setTrackerOfKeyInSession(true);
      if (this.isSeparateMenuVariant) {
        const preEventObj = {
          category: "view cart",
          screenName: this.showSearchModal
            ? PageNames.NEXTGEN_SEARCHPAGE
            : this.loyaltyCard
              ? PageNames.NEXTGEN_REWARD_PAGE
              : PageNames.NEXTGEN_MENUPAGE,
          previousScreenname: this.showSearchModal
            ? PageNames.NEXTGEN_MENUPAGE
            : PageNames.NEXTGEN_HOMEPAGE,
        };
        const eventObj = Utility.amplitudeEventObj(
          "click",
          this.loyaltyCard ? "bottom bar" : "checkout",
          "-1",
          preEventObj,
        );
        if (this.platform) {
          Utility.sendEventToApp("RewardsPageClick", eventObj);
        } else {
          setEvents(
            "amplitude",
            this.loyaltyCard ? "RewardsPageClick" : "Click",
            eventObj,
          );
        }
      } else {
        this.eventFunction(true, {
          category: "view cart",
          screenName: PageNames.NEXTGEN_SEARCHPAGE,
          previousScreenname: PageNames.NEXTGEN_HOMEPAGE,
        });
      }
      userActivityTracking.checkout(0);
      if (Utility.isLoyaltyPage()) {
        Utility.redirectionMultiAsset({
          action: "cart",
          href: "",
          title: "view cart",
        });
      } else {
        Utility.sendToNextGenCart();
      }
    },
  },
  computed: {
    cartQuantity() {
      let _ = this.$store.getters[keyMapsGetter.CART_QUANTITY];
      let loyaltyItemQuant =
        this.$store.getters[keyMapsGetter.CART_LOYALTY_QUANTITY];

      // if (Utility.isLoyaltyPage()) {
      //   let platform = this.platform;
      //   if (!platform) {
      //     platform = Utility.getQueryFromUrlWithSpace(window.location.href)?.[
      //       "platform"
      //     ];
      //   }
      //   if (platform) {
      //     const nonLoyaltyProductQtyFromApp =
      //       (localStorage.nonLoyaltyProductQtyFromApp &&
      //         Number(localStorage.nonLoyaltyProductQtyFromApp)) ||
      //       0;
      //     _ = _ + nonLoyaltyProductQtyFromApp;
      //   }
      // }
      if (this.loyaltyCard) {
        const maxPizzaToBeRedeemed =
          this.$store.state.Loyalty.maxPizzaToBeRedeemed;

        if (maxPizzaToBeRedeemed != undefined && maxPizzaToBeRedeemed != null) {
          if (Number(loyaltyItemQuant) >= Number(maxPizzaToBeRedeemed)) {
            this.$store.commit(keyMapsMutation.UPDATE_MAX_PIZZA_REDEEMED, true);
          } else {
            this.$store.commit(
              keyMapsMutation.UPDATE_MAX_PIZZA_REDEEMED,
              false,
            );
          }
        }
      }
      if (this.isSeparateMenuVariant && !this.showSearchModal) {
        if (this.loyaltyCard) {
          const maxPizzaToBeRedeemed =
            this.$store.state.Loyalty.maxPizzaToBeRedeemed;

          if (
            maxPizzaToBeRedeemed != undefined &&
            maxPizzaToBeRedeemed != null
          ) {
            if (Number(loyaltyItemQuant) >= Number(maxPizzaToBeRedeemed)) {
              this.$store.commit(
                keyMapsMutation.UPDATE_MAX_PIZZA_REDEEMED,
                true,
              );
            } else {
              this.$store.commit(
                keyMapsMutation.UPDATE_MAX_PIZZA_REDEEMED,
                false,
              );
            }
          }
        }
        let initialCartUpdatedByUserActionRef =
          this.$store.state.Cart.initialCartUpdatedByUserActionRef;
        if (initialCartUpdatedByUserActionRef.type == "NONE") {
          return _;
        }

        let preEventObj = {
          eventCategory: "ecommerce",
          eventAction:
            initialCartUpdatedByUserActionRef.type == "REMOVE"
              ? "remove from cart"
              : "add to cart",
          addToCartQuantity:
            initialCartUpdatedByUserActionRef.type == "REMOVE" ? -1 : 1,
          itemName: initialCartUpdatedByUserActionRef.item?.name?.toLowerCase(),
          price: initialCartUpdatedByUserActionRef.item?.itemPrice,
          itemSku: initialCartUpdatedByUserActionRef.item?.id,
          isIrctcOrder: "no",
          size: initialCartUpdatedByUserActionRef.item?.sizeName?.toLowerCase(),
          crust:
            initialCartUpdatedByUserActionRef.item?.crustName?.toLowerCase(),
          ecomCategory:
            initialCartUpdatedByUserActionRef.item?.name?.toLowerCase(),
          positionWithinSection:
            initialCartUpdatedByUserActionRef.positionWithinSection,
        };

        if (initialCartUpdatedByUserActionRef.source == "searchModal") {
          if (
            initialCartUpdatedByUserActionRef.subSource ==
            "nonCustomizableCardAdd"
          ) {
            preEventObj["screenName"] =
              PageNames.NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE;
            preEventObj["previousScreenname"] = PageNames.NEXTGEN_SEARCHPAGE;
          } else if (
            initialCartUpdatedByUserActionRef.subSource == "customisation"
          ) {
            preEventObj["screenName"] =
              PageNames.NEXTGEN_SEARCH_CUSTOMISATIONPAGE;
            preEventObj["previousScreenname"] = PageNames.NEXTGEN_SEARCHPAGE;
          } else {
            preEventObj["screenName"] = PageNames.NEXTGEN_SEARCHPAGE;
            preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
          }
        } else {
          if (
            initialCartUpdatedByUserActionRef.subSource ==
            "nonCustomizableCardAdd"
          ) {
            preEventObj["screenName"] = PageNames.NEXTGEN_NON_CUSTOMISATIONPAGE;
            preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
          } else if (
            initialCartUpdatedByUserActionRef.subSource == "customisation"
          ) {
            preEventObj["screenName"] = PageNames.NEXTGEN_CUSTOISATIONPAGE;
            preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
          } else if (this.loyaltyCard) {
            preEventObj["screenName"] = PageNames.NEXTGEN_REWARD_PAGE;
            preEventObj["pointsRedemption"] =
              initialCartUpdatedByUserActionRef?.item?.reqPointsToRedeem;
          }
        }

        preEventObj["sectionPosition"] =
          initialCartUpdatedByUserActionRef.sectionPosition;

        if (initialCartUpdatedByUserActionRef.sectionName) {
          preEventObj["sectionName"] =
            initialCartUpdatedByUserActionRef.sectionName;
        }

        this.eventFunction(
          true,
          preEventObj,
          initialCartUpdatedByUserActionRef.type == "REMOVE"
            ? "removeFromCart"
            : "addToCart",
        );
      }
      return _;
    },
    cartTotal() {
      return this.$store.getters[keyMapsGetter.CART_TOTAL];
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    paymentOffers() {
      return this.$store.state.PaymentOffers.paymentOffers;
    },
    checkoutTitle() {
      let checkoutTitleText = "View Cart";
      let exp = this.$store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS];
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_I ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_L
      ) {
        checkoutTitleText = "View Cart";
      } else if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_J ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_M
      ) {
        checkoutTitleText = "View Cart";
      }
      return checkoutTitleText;
    },
    hideCartTotal() {
      let exp = this.$store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS];
      return true;
      // return [
      //   VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_K,
      //   VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_L,
      //   VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_M,
      //   VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U
      // ].includes(exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT]);
    },
    isSeparateMenuVariant() {
      return true;
    },
  },
};
</script>
